
import { TurretButton } from "./TurretButton";
import * as Creepts from "endless-siege-engine";

export class TurretButtonsContainer extends Phaser.GameObjects.Container {

    private turretButtons: TurretButton [];

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.y = -60;
        this.x = 80;

        this.turretButtons = [];

        const types = [Creepts.GameConstants.TURRET_PROJECTILE, Creepts.GameConstants.TURRET_LASER, Creepts.GameConstants.TURRET_LAUNCH, Creepts.GameConstants.TURRET_GLUE];

        for (let i = 0; i < 4; i++) {

            const turretButton = new TurretButton(this.scene, types[i], i);
            this.add(turretButton);

            this.turretButtons.push(turretButton);
        }
    }

    public hideButtonsAtTutorialStart(): void {

        for (let i = 0; i < this.turretButtons.length; i ++) {
            
            if (this.turretButtons[i].name === Creepts.GameConstants.TURRET_PROJECTILE) {
                this.turretButtons[i].showHandCursor();
            } else {
                this.turretButtons[i].hide();
            }
        }
    }
}
